export default __webpack_public_path__ + "static/media/facebook-galery.10806332.svg";